import { FC } from "react";

import { Box, styled } from "@mui/material";

import { SATOSContentRender } from "@/components/Application/SATOSContentRender";
import { Step } from "@/components/Procedures/Checklist/Step/Step";
import { useTryUpdateLiveStep } from "@/components/Procedures/Checklist/useTryUpdateLiveStep";
import { isHeader } from "@/components/Procedures/Checklist/utils/Helpers";
import { calculateIsStepActive } from "@/components/Procedures/Checklist/utils/calculateIsStepActive";

import { Checklist } from "@/model/Checklist/Checklist";
import { ProcedureNodeStep } from "@/model/Procedure/ProcedureNodeStep";

const BoxForPreviewChecklists = styled(Box)({
	"& > p:nth-child(4)": {
		borderWidth: 0,
	},
});

interface ChecklistRowProps {
	activeSchemeId: number | undefined;
	step: ProcedureNodeStep;
	checklist?: Checklist;
	materialHandling?: boolean;
	showCommentsAndSuggestion?: boolean | undefined;
	highlightedStepId?: any;
	scrollContainerId?: string;
	isProcedurePage?: boolean;
}

export const ChecklistRow: FC<ChecklistRowProps> = (props) => {
	const isActiveStep = props.isProcedurePage
		? calculateIsStepActive(props.step, props.checklist)
		: false;
	useTryUpdateLiveStep(props.step, isActiveStep);

	if (isHeader(props.step)) {
		return (
			<Box
				className="grid-row grid-row-header"
				style={{ background: props.step.BackgroundColor }}
			>
				{props.isProcedurePage ? (
					<>
						<Box className="grid-column grid-column--header">
							<SATOSContentRender content={props.step.Value} />
						</Box>
						<Box className="grid-column grid-column-blank" />
					</>
				) : (
					<BoxForPreviewChecklists className="grid-column grid-column--header">
						<SATOSContentRender content={props.step.Value} />
					</BoxForPreviewChecklists>
				)}
			</Box>
		);
	}

	return (
		<Step
			activeSchemeId={props.activeSchemeId || 0}
			checklist={props.checklist}
			materialHandling={props.materialHandling}
			step={props.step}
			showCommentsAndSuggestion={props.showCommentsAndSuggestion}
			highlightedStepId={props.highlightedStepId}
			scrollContainerId={props.scrollContainerId}
			isActiveStep={isActiveStep}
		/>
	);
};
